import type DayConfigurationForm from 'modules/work_schedules/lib/forms/DayConfigurationForm'

const findDayConfigurationFormsWithConflicts = (dayConfigForms: DayConfigurationForm[]) => {
  const reducer = (
    dayConfigurationsWithConflicts: DayConfigurationForm[],
    dayConfigForm: DayConfigurationForm
  ) => {
    const exists = dayConfigForms.some(
      (dayConfig: DayConfigurationForm) =>
        dayConfig !== dayConfigForm &&
        dayConfig.get('weekday').value === dayConfigForm.get('weekday').value &&
        dayConfig.get('start_at').value < dayConfigForm.get('end_at').value &&
        dayConfig.get('end_at').value > dayConfigForm.get('start_at').value
    )

    if (exists) {
      return [...dayConfigurationsWithConflicts, dayConfigForm]
    }

    return dayConfigurationsWithConflicts
  }

  return dayConfigForms.reduce(reducer, [])
}

export default findDayConfigurationFormsWithConflicts
